/**
 * How long a counting number should travel. Scaling with the magnitude of the change is
 * the whole point of the effect — a 50-credit change and a 5000-credit change must not
 * take the same time, otherwise only the direction is readable and not the size:
 *
 *   min(900ms, 300ms + digits(delta) * 120ms)
 *
 * Floor 300ms keeps a one-digit change from being a flicker, ceiling 900ms keeps a
 * jackpot from holding the eye hostage. The common 3–4 digit change lands at 660–780ms,
 * next to the flat 600ms the spark balance used before this became shared.
 *
 * Kept free of React on purpose, so it can be tested without dragging the provider tree
 * (and its JSX) into the test transform.
 */

const MIN_MS = 300;
const PER_DIGIT_MS = 120;
const MAX_MS = 900;

/** Decimal digits in the change — 1 for a single-digit delta, 4 for a thousand-something. */
function digitsIn(delta: number): number {
  const abs = Math.abs(Math.round(delta));
  return abs < 10 ? 1 : Math.floor(Math.log10(abs)) + 1;
}

export function countUpDurationMs(delta: number): number {
  return Math.min(MAX_MS, MIN_MS + digitsIn(delta) * PER_DIGIT_MS);
}
